import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { CasesState } from '../storeTypes';
import { resetAction } from '../actions/resetAction';
import { CaseDto } from '../../types/backendType';

const initialState: CasesState = {
  cases: {},
};

const usersSlice = createSlice({
  name: 'usersSlice',
  initialState,
  extraReducers: (builder) => builder.addCase(resetAction, () => initialState),
  reducers: {
    setCasesAction: (
      draftState: CasesState,
      action: PayloadAction<{ cases: CaseDto[]; patientId: string }>,
    ) => {
      const { patientId, cases } = action.payload;
      draftState.cases[patientId] = cases;
    },
    addCaseAction: (
      draftState: CasesState,
      action: PayloadAction<{ newCase: CaseDto; patientId: string }>,
    ) => {
      const { patientId, newCase } = action.payload;
      draftState.cases[patientId] = [...(draftState.cases[patientId] ?? []), newCase];
    },
    // Upsert variant — replaces the existing case row with matching
    // case_id if present, otherwise appends. Used by the EMR import
    // flow which refreshes a case's additional_info on each re-import.
    upsertCaseAction: (
      draftState: CasesState,
      action: PayloadAction<{ caseDto: CaseDto; patientId: string }>,
    ) => {
      const { patientId, caseDto } = action.payload;
      const existing = draftState.cases[patientId] ?? [];
      const idx = existing.findIndex((c) => c.case_id === caseDto.case_id);
      if (idx >= 0) {
        const next = [...existing];
        next[idx] = caseDto;
        draftState.cases[patientId] = next;
      } else {
        draftState.cases[patientId] = [...existing, caseDto];
      }
    },
  },
});

export const { setCasesAction, addCaseAction, upsertCaseAction } = usersSlice.actions;

export default usersSlice;
